<!-- Decorative terrain, drawn for this board; no map or weather observations implied. -->
<div class="winter-scene" aria-hidden="true">
  <svg class="mountains" viewBox="0 0 1600 900" preserveAspectRatio="xMidYMid slice" fill="none">
    <path class="far" d="M0 490 120 405 190 439 355 228 440 330 505 295 690 490 810 387 940 454 1120 235 1265 395 1380 305 1600 470V900H0Z" />
    <path class="snow" d="m190 439 165-211 85 102-65-45-28 70-30-28-50 91-12-25Zm750 15 180-219 145 160-107-83-26 48-26-34-68 92-15-23Z" />
    <path class="near" d="m0 675 220-160 155 81 225-199 172 159 173-77 220 139 207-110 228 122V900H0Z" />
    <path class="ridge" d="m375 596 225-199 172 159-122-70-38 38-24-61-94 94-15-11Z" />
    <g class="trees">
      {#each [40, 81, 123, 164, 215, 263, 310, 1210, 1252, 1301, 1355, 1401, 1448, 1502, 1555] as x, i}
        <path transform="translate({x} {660 + (i % 4) * 22}) scale({0.7 + (i % 3) * 0.22})" d="M0-120 25-70H15L36-25H22L48 26H5V55H-5V26H-48L-22-25H-36L-15-70H-25Z" />
      {/each}
    </g>
    <path class="ground" d="M0 791Q180 744 395 809T830 808T1225 795T1600 758V900H0Z" />
    <path class="drift-line" d="M0 831Q230 789 425 840M1010 853Q1290 783 1600 819" />
  </svg>
  <div class="spindrift"></div>
  <div class="snowbank"></div>
</div>

<style>
  .winter-scene { position: fixed; inset: 0; overflow: hidden; pointer-events: none; z-index: 0; }
  .mountains { position: absolute; width: 100%; height: 100%; opacity: .65; }
  .far { fill: light-dark(#bdcfd0, #223d47); }
  .snow { fill: light-dark(#edf4ef, #3b535d); }
  .near { fill: light-dark(#cedbd7, #1b333b); }
  .ridge { fill: light-dark(#f4f6ee, #35515a); }
  .trees { fill: light-dark(#819d92, #142d30); opacity: .5; }
  .ground { fill: light-dark(#edf2e9, #263e45); }
  .drift-line { stroke: light-dark(#cfdbd4, #3b555e); stroke-width: 2; }
  .snowbank { position: absolute; bottom: -35px; left: -5%; width: 110%; height: 90px; border-radius: 50% 55% 0 0; background: light-dark(#f8f9f0, #344b51); box-shadow: 0 -1px 0 #ffffff40; transform: rotate(-1deg); }
  .spindrift { position: absolute; inset: -80px; opacity: .4; background-image: radial-gradient(ellipse 2px 1px at 12% 23%, #fff 90%, transparent), radial-gradient(ellipse 3px 1px at 64% 72%, #fff 90%, transparent), radial-gradient(ellipse 2px 1px at 81% 42%, #fff 90%, transparent); background-size: 310px 230px, 490px 330px, 380px 290px; animation: drift 24s linear infinite; }
  @keyframes drift { to { transform: translate(160px, 50px); } }
  @media (prefers-reduced-motion: reduce) { .spindrift { animation: none; } }
</style>
